/* global Hls */
import { VIDEOS } from "../../../client/consts";
import falseLoop from "./false-loop";
import { createHlsPlayer } from "./hls";
import { playVideo } from "./playback";
import { logTiming } from "@services/analytics";

// eslint-disable-next-line no-empty-function
const noop = () => { };

/**
 * Cue a video ready to play
 *
 * @param    {HTMLElement} video HTML video element
 * @param    {string} type Player type
 * @param    {string} src Video src
 * @param {Function} prePlayCallback Pre-play callback
 * @returns {object} chained play method
 */
export default function cueVideo(video, type, src, prePlayCallback = noop) {
  const cueing = Date.now();

  // Add do not track parameter to vimeo urls
  if (src.includes("vimeo.com")) {
    const url = new URL(src);
    // url.searchParams.append("dnt", 1);
    // eslint-disable-next-line no-param-reassign
    src = url.href;
  }

  if (type === VIDEOS.DWELL) {
    video.ontimeupdate = falseLoop;
  } else {
    video.ontimeupdate = null;
  }

  if (typeof Hls !== "undefined" && Hls.isSupported()) {
    createHlsPlayer(type, video, src);
  } else {
    video.src = src;
  }

  prePlayCallback();

  return {
    andPlay(callback = noop) {
      playVideo(video);

      if (video.readyState > 2) {
        logTiming(
          "video",
          "playback",
          Date.now() - cueing,
          `${type} video can play (${src})`
        );
        callback();
      } else {
        video.oncanplay = () => {
          logTiming(
            "video",
            "playback",
            Date.now() - cueing,
            `${type} video can play (${src})`
          );
          video.oncanplay = null;
          callback();
        };
      }
    }
  };
}

/**
 * Cue a conversation video ready to play
 *
 * @param    {HTMLElement} video HTML video element
 * @param    {string} src Video src
 * @param {Function} prePlayCallback Pre-play callback
 * @returns {object} chained play method
 */
export function cueConversationVideo(video, src, prePlayCallback) {
  return cueVideo(video, "conversation", src, prePlayCallback);
}

/**
 * Cue a dwell video ready to play
 *
 * @param    {HTMLElement} video HTML video element
 * @param    {string} src Video src
 * @param {Function} prePlayCallback Pre-play callback
 * @returns {object} chained play method
 */
export function cueDwellVideo(video, src, prePlayCallback) {
  return cueVideo(video, "dwell", src, prePlayCallback);
}

/**
 * Cue an intro video ready to play
 *
 * @param    {HTMLElement} video HTML video element
 * @param    {string} src Video src
 * @param {Function} prePlayCallback Pre-play callback
 * @returns {object} chained play method
 */
export function cueIntroVideo(video, src, prePlayCallback) {
  return cueVideo(video, "intro", src, prePlayCallback);
}
